{
  "page": "verify",
  "next": "/verify",
  "options": [],
  "params": [],
  "session": {
    "ecodes": [],
    "address_suggestions": [],
    "supplier_code": "TEST-SUPPLIER-123456",
    "points": [],
    "order_id": "test-order-id-123",
    "cbi_questions": [],
    "required_keys": [],
    "common_docs": {
      "dcd": {
        "date": "2021-11-18",
        "title": "Recurring Electronic Payment Authorization",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/9cde795d5c27368cec554db5c9a1036aae4f9b491d967d9a4f46df299eab553f.html"
      },
      "pp": {
        "date": "2021-11-18",
        "title": "Uplift Privacy Policy",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/996b6e04cd6441597227189cc3fc27a107ad17bbf3a4c570e8bb67f4251db872.html"
      },
      "cip": {
        "date": "2021-11-18",
        "title": "CIP Disclosure",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/c8c56ec5fee5c9408e9809922b710cc279d4c12e46c362e16720ec8d8f29f528.html"
      },
      "tos": {
        "date": "2021-11-18",
        "title": "Terms Of Use",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/2882a56c4c3abc835953c1000a953da219d832bf6521c97a523232d278e5f150.html"
      },
      "localization": {
        "country": "US",
        "language": "en",
        "currency": "USD"
      },
      "esign": {
        "date": "2021-11-18",
        "title": "E-Sign Consent to Receive Electronic Disclosures",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/ea2e44842da96f4351422e12b8a37de4a0452bfd55fcb713ed6dcedee5e666ff.html"
      },
      "cpa": {
        "date": "2021-11-18",
        "title": "Credit Profile Authorization",
        "url": "https://fps6.dev.uplift-platform.com/docs/v1/up-play-us-east-1-kasa/docs/1e503f716ab7e043f20a1f01fa1daf3c358e58b90e49f37a15e5b9bc13056c85.html"
      }
    },
    "loan_offers": [
      {
        "origination_fee": 1457,
        "total_interest": 4139,
        "offer_id": "TEST-OFFER-ID-123",
        "pay_today": 5676,
        "promos": [],
        "finance_charges": 5596,
        "apr": 1505,
        "down_payment": 5676,
        "localization": {
          "country": "US",
          "language": "en",
          "currency": "USD"
        },
        "monthly_payment_amount": 7133,
        "pure_down_payment": 4219,
        "payment_due_day": 14,
        "grand_total": 85596,
        "loan_amount": 74324,
        "total_payments": 78463,
        "order_amount": 80000,
        "financed_amount": 72867,
        "number_of_payments": 11
      }
    ]
  },
  "order_info": {
    "event_tickets": [],
    "rentals": [],
    "travelers": [
      {
        "id": 0,
        "first_name": "Arthur",
        "last_name": "Davis",
        "date_of_birth": "04/07/1963"
      }
    ],
    "billing_contact": {
      "email": "arthur@uplift.com",
      "first_name": "Arthur",
      "phone": "5555559075",
      "last_name": "Davis"
    },
    "hotel_reservations": [],
    "started_at": "2021-12-14",
    "industry": "travel",
    "sequence_id": "TEST-SEQUENCE-ID-123",
    "localization": {
      "country": "US",
      "language": "en",
      "currency": "USD"
    },
    "supplier_code": "TEST-SUPPLIER-123456",
    "points": [],
    "add_ons": [],
    "up_code": "UP-123456",
    "air_reservations": [],
    "order_id": "test-order-id-123",
    "order_lines": [],
    "cruise_reservations": [
      {
        "rooms": [
          {
            "cabin_type": "6V (Interior)",
            "state_room_type": "6V (Interior)",
            "state_room_number": "7447"
          }
        ],
        "embark_date": "20221229",
        "insurance": [
          {
            "types": ["cancellation"],
            "price": 10000
          }
        ],
        "cruise_line": "Royal Caribbean",
        "cruise_duration": 3,
        "add_ons": [],
        "disembark_date": "20230103",
        "itinerary": [
          {
            "departure_port": "Port Canaveral (Orlando), Florida",
            "departure_date": "20221229",
            "arrival_date": "20230103",
            "activities": []
          }
        ],
        "price": 120041,
        "traveler_ids": []
      }
    ],
    "order_amount": 80000,
    "customer_id": ""
  },
  "merchant_name": "Mock Cruise Lines"
}
